import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w100" }
const _hoisted_2 = {
  key: 0,
  class: "fw600"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = {
  key: 1,
  class: "fs12 fw600 mb20 orange"
}
const _hoisted_5 = { class: "selectTableView" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("th", { width: "400" }, null, -1)
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  style: {"width":"30px"},
  class: "fl"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "fs14 fw600" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", {
  class: "fr grey",
  style: {"margin-right":"20px"}
}, "で調整可能", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_14 = { class: "selectTableView" }
const _hoisted_15 = ["width"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_17 = { class: "pad10 llgreyBg mt20" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", { class: "header_title fs14 mt" }, "カスタム設定", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconHelp = _resolveComponent("IconHelp")!
  const _component_AvailableDaysOfWeeksTableCell = _resolveComponent("AvailableDaysOfWeeksTableCell")!
  const _component_ModalInnerAvailableTime = _resolveComponent("ModalInnerAvailableTime")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.hideTitle)
      ? (_openBlock(), _createElementBlock("h5", _hoisted_2, [
          _createTextVNode(_toDisplayString(_ctx.title) + " ", 1),
          _createVNode(_component_IconHelp, {
            width: 18,
            tooltipText: `可能な時間を設定し、その時間内からミーティングを設定します。\n
            個別で可能日時を週次カレンダーから追加した場合、\n
            こちらで設定した可能時間+個別で登録した日時のどちらもが可能日時としてお相手に提案されます。`,
            style: {"margin-top":"-3px","margin-right":"5px"}
          })
        ]))
      : _createCommentVNode("", true),
    _hoisted_3,
    (_ctx.defaultTimezoneValue)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createTextVNode(_toDisplayString(_ctx.defaultTimezoneValue) + "の以下の可能時間を基準に日程を算出します。 ", 1),
          _createElementVNode("span", {
            class: "underline pointer",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeDefaultTimezone && _ctx.changeDefaultTimezone(...args)))
          }, " >> 設定 ")
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("table", _hoisted_5, [
      _hoisted_6,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectTimeThemes, (theme, index) => {
        return (_openBlock(), _createElementBlock("tr", {
          key: `${index}${theme.systemUpdatedAt}${theme.select}`,
          height: "45",
          class: _normalizeClass(`dataEmail ${theme.select == true ? `selected` : ``}`),
          style: {"border-bottom":"1px solid #efefef","line-height":"45px"}
        }, [
          _createElementVNode("td", {
            onClick: ($event: any) => (_ctx.selectTheme(theme))
          }, [
            _createTextVNode("    "),
            _createElementVNode("div", _hoisted_8, [
              _createTextVNode("     "),
              (theme.select)
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, "✔"))
                : (_openBlock(), _createElementBlock("span", _hoisted_10, " "))
            ]),
            _createElementVNode("span", _hoisted_11, _toDisplayString(theme.text), 1),
            _hoisted_12
          ], 8, _hoisted_7)
        ], 2))
      }), 128))
    ]),
    _hoisted_13,
    _createElementVNode("table", _hoisted_14, [
      _createElementVNode("th", { width: _ctx.width }, null, 8, _hoisted_15),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayAdows, (adow, adowindex) => {
        return (_openBlock(), _createBlock(_component_AvailableDaysOfWeeksTableCell, {
          key: `${adow.systemUpdatedAt}${adowindex}`,
          adow: adow,
          onDeleteAdow: _ctx.deleteAdow,
          onUpdateHoliday: _ctx.updateHoliday,
          showDeleteButton: _ctx.showDeleteButton
        }, null, 8, ["adow", "onDeleteAdow", "onUpdateHoliday", "showDeleteButton"]))
      }), 128))
    ]),
    _hoisted_16,
    _createElementVNode("div", _hoisted_17, [
      _hoisted_18,
      _createVNode(_component_ModalInnerAvailableTime, {
        direct: true,
        onUpdate: _ctx.updateAdow,
        onUpdateHoliday: _ctx.updateHoliday
      }, null, 8, ["onUpdate", "onUpdateHoliday"])
    ])
  ]))
}